class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.jsonScript = null;
    this.prevArrow = this.querySelector('.swiper-button-prev');
    this.nextArrow = this.querySelector('.swiper-button-next');
    this.pagination = this.querySelector('.swiper-pagination');
  }

  connectedCallback() {
    this.swiperContainer = this.querySelector('.swiper');
    this.jsonScript = this.querySelector('script[type="application/json"]');
    this.init();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  init() {
    const config = this.getSwiperConfig();

    console.log('config', config);

    this.swiper = new Swiper(this.swiperContainer, config);
  }

  getSwiperConfig() {
    try {
      const userConfig = JSON.parse(this.jsonScript.textContent) || {};
      const defaults = {
        slidesPerView: 1,
        effect: 'fade',
        speed: 500,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.nextArrow,
          prevEl: this.prevArrow,
        },
        pagination: {
          el: this.pagination,
          clickable: true,
        },
        on: {
          init: (swiper) => {
            this.handleVideoPlayback(swiper);
          },
          slideChange: (swiper) => {
            this.handleVideoPlayback(swiper);
          },
        },
      };

      return { ...defaults, ...userConfig };
    } catch (e) {
      console.error('SwiperSlider: JSON parsing error', e);
      return {};
    }
  }

  handleVideoPlayback(swiper) {
    const slides = swiper.slides;
    slides.forEach((slide, index) => {
      const videos = slide.querySelectorAll('video.hero-video');
      if (index === swiper.activeIndex) {
        videos.forEach((video) => {
          video.play().catch((e) => console.log('Autoplay prevented:', e));
        });
      } else {
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  }
}

if (!customElements.get('hero-slider')) {
  document.addEventListener('DOMContentLoaded', () => {
    customElements.define('hero-slider', HeroSlider);
  });
}
